// extracted by extract-css-chunks-webpack-plugin
module.exports = {"offers-animate":"ji-aI","animate":"_2p-r8","specialOfferApplyBtn":"NyD72"};